import { FOOTER_SLOGAN } from "@/data/content";
import { PhoneLink } from "./ContactButtons";
import { SocialIcons } from "./SocialIcons";

export const Footer = () => (
  <footer className="border-t border-white/10 bg-black pb-28 pt-16 lg:pb-16">
    <div className="container mx-auto px-4 sm:px-6 lg:px-8">
      <div className="flex flex-col items-start gap-10 lg:flex-row lg:items-center lg:justify-between">
        <div className="flex flex-col items-start gap-4">
          <img src="/logo-adt-v2.png" alt="ADT | Авто Для Тебе" className="h-14 w-auto object-contain" />
          <PhoneLink className="text-base text-white/80" />
        </div>

        <div className="flex gap-3" data-testid="footer-socials">
          <SocialIcons size="lg" />
        </div>
      </div>

      <div className="mt-12 border-t border-white/10 pt-10">
        <p className="font-heading text-2xl font-semibold leading-snug text-white sm:text-3xl">
          {FOOTER_SLOGAN.line1}
          <br />
          <span className="text-[#B12A2A]">{FOOTER_SLOGAN.line2}</span>
        </p>
        <p className="mt-8 text-sm text-white/40">
          © {new Date().getFullYear()} ADT | Авто для тебе. Підбір • Діагностика • Митниця • Реєстрація.
        </p>
      </div>
    </div>
  </footer>
);
